import React from "react";
import Published from "./Published";

class PublishedHOC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articleType: this.props.match.params.articleType,
    };
  }

  componentDidMount() {
    console.log("Published hoc");
    this.props.history.listen((location) => {
      let newArticleType = location.pathname.split("/")[3];
      this.setState({ articleType: newArticleType });
    });
  }

  render() {
    return <Published articleType={this.state.articleType} />;
  }
}

export default PublishedHOC;

